<div class="container-main"><router-outlet></router-outlet></div>
